import PropTypes from 'prop-types';

export const groupDefinition = PropTypes.shape({
  _id: PropTypes.string,
  name: PropTypes.string,
});
